import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../consts/api";
import { http } from "../../../../services/HttpService";

export const useUpdateGfeStatus = (procedureId) => {
  return useMutation((dto) =>
    http.patch(HTTP_ENDPOINTS.updateProcedureGfeStatus(procedureId), dto),
  );
};
